
  import React from 'react'
  import { MDXTag } from '@mdx-js/tag'
  import { Playground } from 'docz';
import axios from 'axios';
import State from '../../../../docs/State';
import TuiEditor from '@devsisters/ui-common/lib/TuiEditor';

const layoutProps = {
  
};
export default class MDXContent extends React.Component {
  constructor(props) {
    super(props)
    this.layout = null
  }
  render() {
    const { components, ...props } = this.props

    return <MDXTag
             name="wrapper"
             
             components={components}>

<MDXTag name="h1" components={components} props={{"id":"tuieditor"}}>{`TuiEditor`}</MDXTag>
<MDXTag name="p" components={components}><MDXTag name="a" components={components} parentName="p" props={{"href":"https://en.wikipedia.org/wiki/Markdown"}}>{`마크다운`}</MDXTag>{` `}<MDXTag name="a" components={components} parentName="p" props={{"href":"https://en.wikipedia.org/wiki/WYSIWYG"}}>{`위지윅`}</MDXTag>{` 에디터 `}<MDXTag name="a" components={components} parentName="p" props={{"href":"https://github.com/nhnent/tui.editor"}}>{`tui.editor`}</MDXTag>{`를
리액트로 사용하기 편하게 만든 것입니다.`}</MDXTag>
<MDXTag name="pre" components={components}><MDXTag name="code" components={components} parentName="pre" props={{"className":"language-tsx"}}>{`import TuiEditor from '@devsisters/ui-common/lib/TuiEditor';
`}</MDXTag></MDXTag>
<MDXTag name="h2" components={components} props={{"id":"기본"}}>{`기본`}</MDXTag>
<Playground __position={0} __code={'<State initialState={{ value: \'Hello **World**\' }}>\n  {({ state, setState }) => (\n    <>\n      <TuiEditor\n        editType=\"wysiwyg\"\n        onChange={editor => setState({ value: editor.getMarkdown() })}\n        value={state.value}\n      />\n      <button onClick={() => setState({ value: \'Hello **World**\' })}>\n        Reset\n      </button>\n      <pre>{JSON.stringify(state)}</pre>\n    </>\n  )}\n</State>'} __scope={{props: this ? this.props : props,axios,State,TuiEditor}}>
  <State initialState={{ value: 'Hello **World**' }}>
    {({ state, setState }) => (
      <>
        <TuiEditor
          editType="wysiwyg"
          onChange={(editor) => setState({ value: editor.getMarkdown() })}
          value={state.value}
        />
        <button onClick={() => setState({ value: 'Hello **World**' })}>
          Reset
        </button>
        <pre>{JSON.stringify(state)}</pre>
      </>
    )}
  </State>
</Playground>
<MDXTag name="h2" components={components} props={{"id":"커스텀-툴바"}}>{`커스텀 툴바`}</MDXTag>
<Playground __position={1} __code={'<TuiEditor editType=\"wysiwyg\" toolbarItems={[\'heading\', \'bold\', \'italic\']} />'} __scope={{props: this ? this.props : props,axios,State,TuiEditor}}>
  <TuiEditor
    editType="wysiwyg"
    toolbarItems={[
      'heading',
      'bold',
      'italic',
    ]}
  />
</Playground>
<MDXTag name="h2" components={components} props={{"id":"이미지-업로드"}}>{`이미지 업로드`}</MDXTag>
<Playground __position={2} __code={'<TuiEditor\n  fileUploadHandler={(image, source) => {\n    const formData = new FormData()\n    formData.append(\'image\', image)\n    return axios\n      .post(\'https://api.imgur.com/3/image\', formData, {\n        headers: {\n          Authorization: \'Client-ID 53d33327ffa655f\',\n        },\n      })\n      .then(response => response.data.data.link)\n  }}\n/>'} __scope={{props: this ? this.props : props,axios,State,TuiEditor}}>
  <TuiEditor
    fileUploadHandler={(image, source) => {
      const formData = new FormData();
      formData.append('image', image);
      return axios
        .post('https://api.imgur.com/3/image', formData, {
          headers: {
            Authorization: 'Client-ID 53d33327ffa655f',
          },
        })
        .then(response => response.data.data.link);
    }}
  />
</Playground>
           </MDXTag>
  }
}
  